import { lazy } from "react";

/****Layouts*****/
const DssLayout = lazy(() => import("../layouts/DssLayout.js"));
const HomeLayout = lazy(() => import("../layouts/HomeLayout.js"));
/*****Routes******/

/**Pages*/

const LoginView = lazy(() => import("../views/dss/LoginView.js"));
const RecommendSignupView = lazy(() => import("../views/dss/RecommendSignupView.js"));
const SignupView = lazy(() => import("../views/dss/SignupView.js"));
const SignupVerifyView = lazy(() => import("../views/dss/SignupVerifyView.js"));

const ProductView = lazy(() => import("../views/listing/ProductsView.js"));
const ProductDetailsView = lazy(() => import("../views/checkout/viewItem/ProductDetailsView.js"));
const CartView = lazy(() => import("../views/checkout/shoppingcart/ShoppingCartView.js"));
const OrdersView = lazy(() => import("../views/orders/OrdersView.js"));
const AccountView = lazy(() => import("../views/account/AccountView.js"));
const AddressView = lazy(() => import("../views/address/AddressView.js"));
const WishListView = lazy(() => import("../views/wishlist/WishListView.js"));
const ShopView = lazy(() => import("../views/shop/ShopView.js"));
const ShopDetailsView = lazy(() => import("../views/shop/ShopDetailsView.js"));
const ProductHomeView = lazy(() => import("../views/product/ProductHomeView.js"));
const CheckoutView = lazy(() => import("../views/checkout/finalCheckout/CheckoutView.js"));
const CheckoutSuccess = lazy(() => import("../views/checkout/finalCheckout/checkoutCompletion/CheckoutSuccess.js"));
const CheckoutFailure = lazy(() => import("../views/checkout/finalCheckout/checkoutCompletion/CheckoutFailure.js"));

const SecurityView = lazy(() => import("../views/security/SecurityView.js"));
const NameEditView = lazy(() => import("../views/security/NameEditView.js"));
const EmailEditView = lazy(() => import("../views/security/EmailEditView.js"));
const MobileEditView = lazy(() => import("../views/security/MobileEditView.js"));
const PasswordEditView = lazy(() => import("../views/security/PasswordEditView.js"));

const SupportView = lazy(() => import("../views/support/SupportView.js"));


const ThemeRoutes = [
  
  {
    path: "/",
    element: <HomeLayout/>,
    children: [
      { path: "", exact: true, element: <ProductView /> },
      { path: "/*", exact: true, element: <ProductDetailsView /> }
    ],
  },
  /**General partition */
  {
    path: "/gp",
    element: <HomeLayout/>,
    children: [
      { path: "/gp/cart", exact: true, element: <CartView /> },
      { path: "/gp/orders", exact: true, element: <OrdersView /> },
      { path: "/gp/wishlist", exact: true, element: <WishListView /> },
      { path: "/gp/account", exact: true, element: <AccountView /> },
      { path: "/gp/address", exact: true, element: <AddressView/> },
      
    ],
  },

  {
    path: "/checkout",
    element: <HomeLayout/>,
    children: [
      { path: "", exact: true, element: <CheckoutView /> },
      { path: "/checkout/success", exact: true, element: <CheckoutSuccess /> },
      { path: "/checkout/failure", exact: true, element: <CheckoutFailure /> },
    ],
  },

  {
    path: "/shop",
    element: <HomeLayout/>,
    children: [
      { path: "", exact: true, element: <ShopView/> },
      { path: "/shop/*", exact: true, element: <ShopDetailsView/> },
    ]
  },

  {
    path: "/product",
    element: <HomeLayout/>,
    children: [
      { path: "/product/*", exact: true, element: <ProductHomeView/> },
    ]
  },

  {
    path: "/dss",
    element: <DssLayout/>,
    children: [
      { path: "signin", exact: true, element: <LoginView /> },
      { path: "signup_r", exact: true, element: < RecommendSignupView/> },
      { path: "signup", exact: true, element: < SignupView/> },
      { path: "signup/verify", exact: true, element: < SignupVerifyView/> },
    ],
  },

  {
    path: "/security",
    element: <DssLayout/>,
    children: [
      { path: "", exact: true, element: <SecurityView /> },
      { path: "name", exact: true, element: <NameEditView /> },
      { path: "email", exact: true, element: <EmailEditView /> },
      { path: "mobile", exact: true, element: <MobileEditView /> },
      { path: "password", exact: true, element: <PasswordEditView /> },
    ],
  },

  {
    path: "/support",
    element: <HomeLayout/>,
    children: [
      { path: "", exact: true, element: <SupportView /> },
    ],
  }




];

export default ThemeRoutes;
